<template>
	<div class="">
        <template v-if="create_payroll_batch === true && autoPayroll !== null ">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Generate Payroll </h1>
                <button class="btn btn-primary float-right" @click="proceedToEarning"> Next</button>
                <button class="btn btn-primary float-right mr-1" @click="cancelAutoGeneratePayroll">Cancel</button>
                <div class="head-date float-right mr-2"> {{autoPayroll_date}} <i class="far fa-clock"></i> </div>
            </div>
            <hr class="border" />
            <div class="row normal-ib-space align-items-center mb-3">
                <div class="col-md-3"> <input id="customSearch" type="text" class="form-control search" placeholder="Search employee by name or Wallet Number" title="Search employee by name or Wallet Number" name="" /> </div>
                <div class="col-md-9">
                    <ul class="page-status text-right border-bottom-0 p-0">
                        <li class="page-status-list done">
                            <router-link :to="/autoPaymentUsers/+$route.params.id">
                                <span class="status-highlighter">1</span>Employees
                            </router-link>
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">2</span>
                            Time Off
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">3</span>
                            Earnings
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">4</span>
                            Review and Submit
                        </li>
                    </ul>
                </div>
            </div>
            <div class="autogenerate-content">
                <table id="dt-autogenerate-timeoff" class="table" style="width:100%">
                    <thead>
                        <tr>
                            <th>Employees</th>
                            <th>Time-off / Absents</th>
                            <th>Total Deductibles</th>
                            <th>Total Deductions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="tou in time_off_users" v-bind:key="tou.id">
                            <td class="">
                                <div class="image-title">
                                    <div class="image-holder entity-detail-tooltip" data-toggle="tooltip">
                                        <img v-if="tou.user.avatar != null" :src="'/avatar/'+tou.user.avatar" alt="" />
                                        <img v-else src="/images/table-dummy-image.jpg" alt="" />
                                    </div>
                                    <div class="ag-employee-part">
                                        <span class="name"> {{tou.user.name}} </span>
                                        <span class="emp-status"> {{tou.user.status}} </span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span v-if="leaveSum(tou.timeOff) > 0">
                                    Un-paid Leaves: {{leaveSum(tou.timeOff)}},[{{leaveType(tou.timeOff)}}] <br/>
                                    Deduction: {{leaveAmount(tou.timeOff)}}<br/>
                                </span>
                                Working Days: {{ workingDays(tou.timeOff) }} <br/>
                                Absents: {{ absentDays(tou.timeOff) }} <br/>
                                Deduction: {{ deductableAmount(tou.timeOff) }} <br/>
                            </td>
                            <td> <input type="text" readonly="" :value="deductableAmount(tou.timeOff)" class="form-control" /> </td>
                            <td> <input type="text" value="" v-model="tou.deduction" class="form-control" /> </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template v-else-if="create_payroll_batch === null && autoPayroll == null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="create_payroll_batch === false">
            <notAllowed></notAllowed>
        </template>
	</div>
</template>

<script>
    var dtAutoGenerateTable = null;
    export default {
        data() {
            return {
                create_payroll_batch:  null,
                time_off_users: [],
                autoPayroll: null,
                autoPayroll_date: ''
            }
        },
        methods: {
            getAutoGenerateTimeOffData(){
                this.$Progress.start();
                axios.get("/api/autoPaymentTimeOff/"+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.autoPayroll    = res.data.autoGenPayroll;
                        this.time_off_users = res.data.records;
                        var date = moment(this.autoPayroll.from_date);
                        this.autoPayroll_date = date.format('MMMM, YYYY');
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', "Error to load data")
                    }
                })
                .then(res => {
                    this.callDataTable();
                })
                .catch(err => {
                    this.$Progress.fail();
                    console.log(err);
                    this.showAlertBox('error', "Error to load data")
                });
            },
            callDataTable(){
                var that = this;
                dtAutoGenerateTable = $('#dt-autogenerate-timeoff').DataTable({
                    "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    "searching":true,
                    columnDefs: [ {
                        orderable: false,
                    }],
                    order: [[ 0, "desc" ]],
                });
                $(document).ready(function() {
                    $('.list a').click(function(event){
                        event.stopPropagation();
                    })
                    $('#customSearch').on( 'keyup', function () {
                        dtAutoGenerateTable.search( this.value ).draw();
                    });

                    // Tooltips code
                    var vendorDetailTooltip = '<div class="autogenerate-detail-tooltip">' +
                                                    '<h2> Jawad Amjad </h2>'+
                                                    '<p class="custom-tooltip-content">' +
                                                        '<span class="tooltip-col tooltip-title"> Account Type </span>' +
                                                        '<span class="tooltip-col">  SIMSIM </span>' +
                                                    '</p>' +
                                                    '<p class="custom-tooltip-content">' +
                                                        '<span class="tooltip-col tooltip-title"> SimSim/Account No. </span>' +
                                                        '<span class="tooltip-col"> 923784613136 </span>' +
                                                    '</p>' +
                                                    '<p class="custom-tooltip-content">' +
                                                        '<span class="tooltip-col tooltip-title"> Employment Status </span>' +
                                                        '<span class="tooltip-col"> PERMANENT </span>' +
                                                    '</p>' +
                                                    '<p class="custom-tooltip-content">' +
                                                        '<span class="tooltip-col tooltip-title"> Department </span>' +
                                                        '<span class="tooltip-col"> Development </span>' +
                                                    '</p>' +
                                                '</div>';
                    $(".entity-detail-tooltip").tooltip({
                        title: vendorDetailTooltip,
                        html: true,
                        placement: 'top',
                        offset: '80',
                        template: '<div class="tooltip custom-tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'

                    });
                    $('#selectAllcheck').on('change', function(){
                        if ($(this).prop('checked')) {
                            $('.list .dropdown-link').addClass('searched');
                            dtAutoGenerateTable.rows().select();
                            $(this).parent().siblings('.drop-value-changer').html("All");
                        }else{
                            $('.list .dropdown-link').removeClass('searched');
                            dtAutoGenerateTable.rows().deselect();
                            $(this).parent().siblings('.drop-value-changer').html("Select Category");
                        }
                    })
                });
            },
            cancelAutoGeneratePayroll(){
              swal.fire({
                    title: 'Are you sure?',
                    // text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    var id = this.autoPayroll.id;
                    if (result.value) {
                        axios.post('/api/cancelAutoGeneratePayroll', {id})
                            .then(res => {
                                if(res.data.status == '200'){
                                    this.showToastBox('success',res.data.msg);
                                    this.$router.push('/employeePayments');
                                }else{
                                    this.showToastBox('error',res.data.msg);
                                }
                            })
                            .catch(err => {
                                this.showAlertBox('error','System Not Responding Please Try Again');
                            });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        this.showAlertBox('error','Cancelled','Your decision has been cancelled');
                    }
                });
            },
            proceedToEarning(){
                this.$Progress.start();
                var formData = {
                    payroll_id      : this.autoPayroll.id,
                    deductions      : this.time_off_users,
                };
                axios.post('/api/processAutoTimeoffPayroll', formData)
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success',res.data.msg);
                        this.$router.push('/autoPaymentEarnings/'+res.data.batch_id);
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            workingDays(value){
                var json_data = JSON.parse(value);
                return json_data.working_days;
            },
            absentDays(value){
                var json_data = JSON.parse(value);
                return json_data.absents;
            },
            deductableAmount(value){
                var json_data = JSON.parse(value);
                var amount = this.formatAmount(json_data.absentsAmount);
                return amount;
            },
            leaveSum(value){
                var json_data = JSON.parse(value);
                return json_data.leave_sum;
            },
            leaveAmount(value){
                var json_data = JSON.parse(value);
                return json_data.leavesAmount;
            },
            leaveType(value){
                var json_data = JSON.parse(value);
                return json_data.leave_type;
            }
        },
        created() {
            //
        },
        mounted() {
            this.$Progress.start();
			this.can('create_payroll_batch').then(result => {
                this.create_payroll_batch = result.create_payroll_batch;
            }).then(result => {
                if(this.create_payroll_batch == true){
					this.getAutoGenerateTimeOffData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
